import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

export default function AdminDashboard() {

  const [date, setDate] = useState("");
  const [bookings, setBookings] = useState([]);
  const [search, setSearch] = useState("");

  const [statusFilter, setStatusFilter] = useState("all");

  const [editingBooking, setEditingBooking] = useState(null);

  const openEditModal = (booking) => {
  setEditingBooking(booking);
};


const saveBooking = async () => {

  const res = await fetch(
    "https://brightlifephysio.com/api/updateBooking.php",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(editingBooking)
    }
  );

  const data = await res.json();

  if (data.status === "success") {

    alert("Booking updated");

    setEditingBooking(null);

    fetchBookings();

  }

};

  const [walkin, setWalkin] = useState({
  firstName: "",
  phone: "",
  service: "physio",
  slot: "",
  isVip: false,
  isEmergency: false
});

const fetchBookings = () => {

  if (!date) return;

  fetch(
    `https://brightlifephysio.com/api/getBookings.php?date=${date}`
  )
    .then((res) => res.json())
    .then((data) => {

      if (data.status === "success") {

        setBookings(data.data);

      }

    });

};
  // Set today's date
  useEffect(() => {

    const today = new Date()
      .toISOString()
      .split("T")[0];

    setDate(today);

  }, []);

useEffect(() => {

  fetchBookings();

  const interval = setInterval(() => {

    fetchBookings();

  }, 30000);

  return () => clearInterval(interval);

}, [date]);

  // Update booking status
  const updateStatus = async (id, status) => {

    await fetch(
      "https://brightlifephysio.com/api/updateStatus.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id,
          status
        })
      }
    );

    // Update UI instantly
    setBookings((prev) =>
      prev.map((b) =>
        b.id === id
          ? { ...b, status }
          : b
      )
    );
  };


const filteredBookings = bookings.filter((b) => {

  const q = search.toLowerCase();

  const matchesSearch =
    b.first_name?.toLowerCase().includes(q) ||
    b.last_name?.toLowerCase().includes(q) ||
    b.phone?.includes(q);

  const matchesStatus =
    statusFilter === "all"
      ? true
      : b.status === statusFilter;

  return matchesSearch && matchesStatus;

});


const bookWalkin = async () => {

  if (
    !walkin.firstName ||
    !walkin.phone ||
    !walkin.slot
  ) {
    alert("Please fill required fields");
    return;
  }

  const payload = {
    firstName: walkin.firstName,
    lastName: "",
    phone: walkin.phone,
    email: "",
    dob: "",
    gender: "",
    firstVisit: "yes",
    concern: walkin.isEmergency
      ? "Emergency Walk-In"
      : "Walk-In",

    service: walkin.service,
    date: date,
    slot: walkin.slot
  };

  try {

    const res = await fetch(
      "https://brightlifephysio.com/api/book.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.status === "success") {

      alert(
        `Booking Confirmed\nCabin: ${data.assigned_cabin}`
      );

      // reload bookings
      fetchBookings();

      // clear form
      setWalkin({
        firstName: "",
        phone: "",
        service: "physio",
        slot: "",
        isVip: false,
        isEmergency: false
      });

    } else {

      alert(data.message);

    }

  } catch (err) {

    alert("Booking failed");

  }

};


const groupedCabins = bookings.reduce((acc, booking) => {

  if (!acc[booking.cabin]) {
    acc[booking.cabin] = [];
  }

  acc[booking.cabin].push(booking);

  return acc;

}, {});




const getCurrentSlot = () => {

  const now = new Date();

  const currentMinutes =
    now.getHours() * 60 + now.getMinutes();

  const slots = [

    "9:30-10:30",
    "10:30-10:45",
    "10:45-11:45",
    "11:45-12:00",
    "12:00-1:00",
    "1:00-1:15",
    "1:15-2:00",
    "2:00-3:00",
    "3:00-3:15",
    "3:15-4:15",
    "4:15-4:30",
    "4:30-5:30",
    "5:30-5:45",
    "5:45-6:45",
    "6:45-7:00",
    "7:00-8:00"

  ];

  const convert = (time) => {

    let [h, m] = time.split(":").map(Number);

    // Convert PM times
    if (h < 9) h += 12;

    return h * 60 + m;
  };

  for (let slot of slots) {

    const [start, end] = slot.split("-");

    const startMin = convert(start);
    const endMin = convert(end);

    if (
      currentMinutes >= startMin &&
      currentMinutes <= endMin
    ) {
      return slot;
    }
  }

  return null;
};

const currentSlot = getCurrentSlot();

const liveBookings = bookings.filter(
  (b) =>
    b.time_slot === currentSlot &&
    b.status !== "cancelled"
);




  return (

    <AdminLayout>

      {/* PAGE TITLE */}
      <div className="top-bar">

        <div>
          <h2 style={{ margin: 0 }}>
            📊 Clinic Dashboard
          </h2>

          <p style={{ margin: 0, color: "#666" }}>
            Manage appointments & cabins
          </p>
        </div>

      </div>

      {/* SUMMARY CARDS */}
      <div className="cards-grid">

        <div className="card-mini">
          <h3>{bookings.length}</h3>
          <p>Today's Bookings</p>
        </div>

        <div className="card-mini">
          <h3>
            {
              bookings.filter(
                (b) => b.status === "pending"
              ).length
            }
          </h3>
          <p>Waiting</p>
        </div>

        <div className="card-mini">
          <h3>
            {
              bookings.filter(
                (b) => b.status === "completed"
              ).length
            }
          </h3>
          <p>Completed</p>
        </div>

        <div className="card-mini">
          <h3>
            {
              bookings.filter(
                (b) => b.status === "cancelled"
              ).length
            }
          </h3>
          <p>Cancelled</p>
        </div>

      </div>

      {/* FILTER BAR */}
      <div className="filter-bar">

       <input
  placeholder="Search patient / phone"
  className="dashboard-input"
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>

      <select
  className="dashboard-input"
  value={statusFilter}
  onChange={(e) =>
    setStatusFilter(e.target.value)
  }
>
  <option value="all">All Status</option>
  <option value="waiting">waiting</option>
  <option value="completed">completed</option>
  <option value="cancelled">cancelled</option>
</select>

        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="dashboard-input"
        />

      </div>

        <div className="walkin-card">

  <h3>➕ Walk-In Booking</h3>

  <div className="walkin-grid">

    <input
      placeholder="Patient Name"
      className="dashboard-input"
      value={walkin.firstName}
      onChange={(e) =>
        setWalkin({
          ...walkin,
          firstName: e.target.value
        })
      }
    />

    <input
      placeholder="Phone Number"
      className="dashboard-input"
      value={walkin.phone}
      onChange={(e) =>
        setWalkin({
          ...walkin,
          phone: e.target.value
        })
      }
    />

    <select
      className="dashboard-input"
      value={walkin.service}
      onChange={(e) =>
        setWalkin({
          ...walkin,
          service: e.target.value
        })
      }
    >
      <option value="physio">Physiotherapy</option>
      <option value="sports">Sports Rehab</option>
      <option value="manual">Manual Therapy</option>
      <option value="dry">Dry Needling</option>
      <option value="posture">Posture Correction</option>
      <option value="hydro">Hydro Therapy</option>
    </select>

    <select
      className="dashboard-input"
      value={walkin.slot}
      onChange={(e) =>
        setWalkin({
          ...walkin,
          slot: e.target.value
        })
      }
    >

      <option value="">
        Select Slot
      </option>

      <option>9:30-10:30</option>
      <option>10:45-11:45</option>
      <option>12:00-1:00</option>
      <option>2:00-3:00</option>
      <option>3:15-4:15</option>
      <option>4:30-5:30</option>
      <option>5:45-6:45</option>
      <option>7:00-8:00</option>

    </select>

  </div>

  <div className="walkin-options">

    <label>
      <input
        type="checkbox"
        checked={walkin.isVip}
        onChange={(e) =>
          setWalkin({
            ...walkin,
            isVip: e.target.checked
          })
        }
      />

      VIP
    </label>

    <label>
      <input
        type="checkbox"
        checked={walkin.isEmergency}
        onChange={(e) =>
          setWalkin({
            ...walkin,
            isEmergency: e.target.checked
          })
        }
      />

      Emergency
    </label>

  </div>

  <button
    className="walkin-btn"
    onClick={bookWalkin}
  >
    Book Walk-In
  </button>

</div>

<div className="live-panel">

  <div className="live-header">

    <h3>🟢 LIVE NOW</h3>

    <span>
      {currentSlot || "No Active Slot"}
    </span>

  </div>

  {liveBookings.length === 0 ? (

    <p>No active appointments</p>

  ) : (

    <div className="live-grid">

      {liveBookings.map((b, i) => (

        <div
          key={i}
          className="live-card"
        >

          <h4>{b.cabin}</h4>

          <p>
            {b.first_name} {b.last_name}
          </p>

          <small>
            {b.service}
          </small>

        </div>

      ))}

    </div>

  )}

</div>



      {/* BOOKINGS TABLE */}
      <div className="table-card">

        <table className="dashboard-table">

          <thead>

            <tr>
              <th>Time</th>
              <th>Patient</th>
              <th>Phone</th>
              <th>Service</th>
              <th>Cabin</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>

          </thead>

          <tbody>

            {bookings.length === 0 ? (

              <tr>
                <td
                  colSpan="7"
                  style={{
                    textAlign: "center",
                    padding: 20
                  }}
                >
                  No bookings found
                </td>
              </tr>

            ) : (

              filteredBookings.map((b, i) => (

                <tr
  key={i}
  style={{
    background:
      b.time_slot === currentSlot
        ? "#f6ffed"
        : "transparent"
  }}
>

                  <td>{b.time_slot}</td>

                  <td>
                    {b.first_name} {b.last_name}
                  </td>

                  <td>{b.phone}</td>

                  <td>{b.service}</td>

                  <td>{b.cabin || "-"}</td>

                  <td>

                    <span
                      style={{
                        padding: "5px 10px",
                        borderRadius: 20,
                        fontSize: 12,
                        background:
                          b.status === "completed"
                            ? "#e6f7ee"
                            : b.status === "cancelled"
                            ? "#fdecea"
                            : "#fff5e6",

                        color:
                          b.status === "completed"
                            ? "green"
                            : b.status === "cancelled"
                            ? "red"
                            : "#d48806"
                      }}
                    >
                      {b.status}
                    </span>

                  </td>

                  <td>

                    <div
                      style={{
                        display: "flex",
                        gap: 8
                      }}
                    >

                      <button
                        className="complete-btn"
                        onClick={() =>
                          updateStatus(
                            b.id,
                            "completed"
                          )
                        }
                      >
                        ✓
                      </button>

                      <button
                        className="cancel-btn"
                        onClick={() =>
                          updateStatus(
                            b.id,
                            "cancelled"
                          )
                        }
                      >
                        ✕
                      </button>

                      <button
  className="edit-btn"
  onClick={() => openEditModal(b)}
>
  ✏
</button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>


      <div className="cabin-section">

  <h3>🏥 Cabin Board</h3>

  <div className="cabin-grid">

    {Object.keys(groupedCabins).map((cabin) => (

      <div
        key={cabin}
        className="cabin-card"
      >

        <div className="cabin-header">

          <h4>{cabin}</h4>

          <span>
            {groupedCabins[cabin].length} Patients
          </span>

        </div>

        <div className="cabin-bookings">

          {groupedCabins[cabin].map((b, i) => (

            <div
              key={i}
              className="cabin-booking-item"
            >

              <div>

                <strong>{b.time_slot}</strong>

                <div className="cabin-patient">
                  {b.first_name} {b.last_name}
                </div>

              </div>

              <span
                className={`status-badge ${b.status}`}
              >
                {b.status}
              </span>

            </div>

          ))}

        </div>

      </div>

    ))}

  </div>

</div>


  {editingBooking && (

  <div className="modal-overlay">

    <div className="edit-modal">

      <h3>Edit Booking</h3>

      <input
        className="dashboard-input"
        value={editingBooking.first_name}
        onChange={(e) =>
          setEditingBooking({
            ...editingBooking,
            first_name: e.target.value
          })
        }
      />

      <input
        className="dashboard-input"
        value={editingBooking.phone}
        onChange={(e) =>
          setEditingBooking({
            ...editingBooking,
            phone: e.target.value
          })
        }
      />

     <select
  className="dashboard-input"
  value={editingBooking.cabin || ""}
  onChange={(e) =>
    setEditingBooking({
      ...editingBooking,
      cabin: e.target.value
    })
  }
>

  <option value="">Select Cabin</option>

  <option>Cabin 1</option>
  <option>Cabin 2</option>
  <option>Cabin 3</option>
  <option>Cabin 4</option>
  <option>Cabin 5</option>
  <option>Flexible/VIP 1</option>
  <option>Flexible/VIP 2</option>

</select>

      <div style={{
        display: "flex",
        gap: 10,
        marginTop: 15
      }}>

        <button
          className="walkin-btn"
          onClick={saveBooking}
        >
          Save
        </button>

        <button
          className="cancel-btn"
          onClick={() =>
            setEditingBooking(null)
          }
        >
          Close
        </button>

      </div>

    </div>

  </div>

)}

    </AdminLayout>

    

  );


}